import { useAppState } from 'hooks/useAppState';

export const useSectionsEditorState = () => {
  const { sectionsEditorState } = useAppState();

  return sectionsEditorState;
};
